import { RequestModel } from "model";

import { useSchool } from "~components/FormFields";
import RequestForm from "~components/RequestForm/RequestForm";
import { useURLSearchParams } from "~utils";

export function RequestFormParams() {
  const urlParam = useURLSearchParams();

  const schoolParam = urlParam.get("school");
  const school = useSchool(schoolParam || "");

  if (!school) {
    return <div>Loading...</div>;
  }

  const timeParams = urlParam.get("intervals");
  const teacherParam = urlParam.get("teacher");
  const gradeParam = urlParam.get("grade");
  const subjectParam = urlParam.get("subject");
  const frontlineId = urlParam.get("frontlineId");
  const budget = urlParam.get("budget");
  const position = urlParam.get("position");

  const times = JSON.parse(timeParams || "[]");
  const usableTimes = times.map((ele: Array<number>, idx: number) => {
    return {
      // db/id doesn't matter.
      "db/id": idx,
      "interval/start": new Date(ele[0]).toISOString(),
      "interval/start-offset": 480,
      "interval/end": new Date(ele[1]).toISOString(),
      "interval/end-offset": 480,
    };
  });

  const newRequest = new RequestModel({
    "sub-req/school": school?.raw,
    "sub-req/time": usableTimes,
    "sub-req/teacher": teacherParam || "",
    "sub-req/grade": gradeParam || "",
    "sub-req/subject": subjectParam || "",
    "frontline/absence-id": frontlineId || "",
    "sub-req/budget": budget ? { id: budget } : undefined,
    "sub-req/position": position ? { "db/id": parseInt(position) } : undefined,
  });

  return (
    <div className="mw-800">
      <h1>Request Sub AMS</h1>
      <RequestForm schools={[school]} request={newRequest} mode="create"></RequestForm>
    </div>
  );
}
